module.exports = __webpack_public_path__ + "img/06_h.ef832939.webp";